import { createApi } from "@reduxjs/toolkit/query/react";
import { buildBaseQuery } from "@app/api";
import { FilterParams } from "types";

import { ITeam, TeamCreationPayload } from "../types/index";

export const teamApi = createApi({
  reducerPath: "teamApi",
  baseQuery: buildBaseQuery(""),
  endpoints: (builder) => ({
    getTeams: builder.query<{ teams: ITeam[]; count: number}, Partial<FilterParams>>({
      query: (params) => {
        const queryString = Object.entries(params)
          .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
          .join('&');

        return `/teams/dashboard?${queryString}`;
      },
    }),
    getTeamById: builder.query<ITeam, string>({
      query: (teamId) => `/teams/${teamId}`,
    }),
    createTeam: builder.mutation<void, TeamCreationPayload>({
      query: (body) => ({
        url: "/teams",
        method: "POST",
        body,
      }),
    }),
    updateTeam: builder.mutation<void, {id: string; body: TeamCreationPayload}>({
      query: ({ id, body }) => ({
        url: `/teams/${id}`,
        method: "PATCH",
        body,
      }),
    }),
    updateTeamConfiguration: builder.mutation<void, {
      id: string;
      body: {
        bestSeller?: boolean;
        activeInHome?: boolean;
      };
    }>({
      query: ({ id, body }) => ({
        url: `/teams/${id}/config`,
        method: "PATCH",
        body,
      }),
    }),
    updateTeamOrdering: builder.mutation<void, { body: { ids: string[] } }>({
      query: ({ body }) => ({
        url: `/teams/update-ordering`,
        method: "PATCH",
        body,
      }),
    }),
    deleteTeam: builder.mutation<void, { id: string }>({
      query: ({ id }) => ({
        url: `/teams/${id}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useUpdateTeamOrderingMutation,
  useGetTeamsQuery,
  useLazyGetTeamsQuery,
  useDeleteTeamMutation,
  useCreateTeamMutation,
  useUpdateTeamMutation,
  useUpdateTeamConfigurationMutation,
  useLazyGetTeamByIdQuery,
} = teamApi;
